import { Newspaper, ExternalLink } from "lucide-react";

function timeAgo(ts) {
  if (!ts || ts.length < 8) return "";
  // Alpha Vantage time_published format: 20260214T101500
  try {
    const y = ts.slice(0, 4), m = ts.slice(4, 6), d = ts.slice(6, 8);
    const hh = ts.slice(9, 11), mm = ts.slice(11, 13);
    return `${y}-${m}-${d} ${hh}:${mm}`;
  } catch {
    return ts;
  }
}

function sentColor(label) {
  const l = String(label).toLowerCase();
  if (l.includes("bullish")) return "text-green-400 border-green-500/30 bg-green-500/5";
  if (l.includes("bearish")) return "text-red-400 border-red-500/30 bg-red-500/5";
  return "text-zinc-400 border-white/10 bg-white/[0.03]";
}

export default function NewsPanel({ items = [], title = "Market Newsflow" }) {
  return (
    <div className="border border-white/10 bg-[#121215] p-5" data-testid="news-panel">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Newspaper className="w-4 h-4 text-zinc-300" strokeWidth={1.8} />
          <h3 className="font-display text-xl font-bold tracking-tight text-white">
            {title}
          </h3>
        </div>
        <span className="font-mono text-[10px] tracking-[0.2em] text-zinc-500 uppercase">
          {items.length} headlines
        </span>
      </div>
      <div className="flex flex-col divide-y divide-white/5 max-h-[420px] overflow-y-auto">
        {items.length === 0 && (
          <p className="text-xs text-zinc-500 font-mono py-4">No headlines available.</p>
        )}
        {items.map((n, i) => (
          <a
            key={i}
            href={n.url}
            target="_blank"
            rel="noopener noreferrer"
            className="py-3 flex flex-col gap-1 group"
            data-testid={`news-item-${i}`}
          >
            <div className="flex items-center justify-between gap-2">
              <span className="font-mono text-[10px] tracking-[0.2em] text-zinc-500 uppercase">
                {n.source} · {timeAgo(n.time_published)}
              </span>
              <span
                className={`font-mono text-[10px] tracking-wider px-1.5 py-0.5 border ${sentColor(
                  n.overall_sentiment_label
                )}`}
              >
                {(n.overall_sentiment_label || "neutral").toUpperCase()}
              </span>
            </div>
            <h4 className="text-sm font-medium text-zinc-100 group-hover:text-white leading-snug flex items-start gap-1">
              {n.title}
              <ExternalLink className="w-3 h-3 mt-1 text-zinc-600 group-hover:text-white flex-shrink-0" />
            </h4>
            {n.ticker_sentiment && n.ticker_sentiment.length > 0 && (
              <div className="flex flex-wrap gap-1 mt-1">
                {n.ticker_sentiment.slice(0, 6).map((t, j) => (
                  <span
                    key={j}
                    className="font-mono text-[9px] tracking-wider px-1.5 py-0.5 border border-white/10 text-zinc-400"
                  >
                    {t.ticker}
                  </span>
                ))}
              </div>
            )}
          </a>
        ))}
      </div>
    </div>
  );
}
